const ocr_callback_success_msg = document.querySelector('.ocrcb-s-text');
const ocr_callback_failure_msg = document.querySelector('.ocrcb-f-text');

if (Boolean(ocr_callback_success_msg) || Boolean(ocr_callback_failure_msg)) {

    function getQueryParameterByName(name) {
        var url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    function ocrCallback() {
        const status = getQueryParameterByName('acquisitionStatus');
        status && status.toLowerCase() === 'success' ? (ocr_callback_success_msg && ocr_callback_success_msg.classList.remove('d-none')) : (ocr_callback_failure_msg && ocr_callback_failure_msg.classList.remove('d-none'));
    }

}